/*
* Report common utilities & components
*/

import * as _ from 'lodash';
import * as React from 'react';
import { Row } from 'react-bootstrap';

import { BootstrapColXl as Col } from '../../common/bootstrap/bootstrapcolxl';
import { Formatters } from '../../common/formatters';

// FORMATTERS
export const PropertyReportItem = ({ title = '', titleAppend = ':', titleColXs = 2, titleClassName = '', childrenColXs = 10, childrenWrapperClassName = '', children, ...rest }) => {
    return (
        <Row>
            <Col xs={titleColXs} className={`pdf-association-property-report-item-title ${titleClassName}`}>
                {title}{titleAppend}
            </Col>
            <Col xs={childrenColXs}>
                <div className={`pdf-association-property-report-item-children-wrapper ${childrenWrapperClassName}`}>
                    {children}
                </div>
            </Col>
        </Row>
    );
};

export const PropertyReportTableItem = ({ title = '', titleAppend = ':', value = '', colTitleClassName = 'col-width-65', colClassName = 'col-width-33', ...rest }) => {
    return (
        <div className={`inline-block ${colClassName}`}>
            <span className={`inline-block ${colTitleClassName}`}>
                {title}{titleAppend}
            </span>

            <span className="inline-block">
                {value}
            </span>
        </div>
    );
};

export const PropertyReportItemSpacer = ({ colClassName = 'pdf-association-property-report-item-spacer', ...rest }) => {
    return (
        <Row>
            <Col xs={12} className={colClassName}>
                &nbsp;
            </Col>
        </Row>
    );
};

export const PropertyLocationItems = ({ locationObj, appTextCommon, ...rest }) => {
    if (!locationObj || !appTextCommon) { return (<div className="property-location-items-empty" />); }

    const locationPropMap = [
        { title: 'location.address', field: 'address1' },
        { title: 'location.address2', field: 'address2' },
        { title: 'location.city', field: 'city' },
        { title: 'location.state', field: 'stateCode' },
        { title: 'location.zip', field: 'postalCode' },
    ];

    const result = _.map(locationPropMap, (o, i) => {
        const val = Formatters.getStr(locationObj, o.field);
        if (!val) { return null; }

        return (
            <PropertyReportItem
                title={appTextCommon(o.title)}
                key={`propertyLocationItem-${i}`}
            >
                {val}
            </PropertyReportItem>
        );
    });

    return (<div className="result-div-class-name">{result}</div>);
};

// PAGE CONTAINERS
export const PropertyReportPage = ({ wrapperClassName = '', className = '', reportData, ...rest }) => {
    return (
        <div className={`pdf-association-property-report-page-wrapper ${wrapperClassName}`}>
            <div className={`pdf-association-property-report-page ${className}`}>{rest.children}</div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/association/property-report/report-components.tsx